import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import * as styles from "./Result.module.css";

export const Result = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div>
        <p className={styles.result}>
          Zachet.KZ сократил общую задолженность на 86% (из 302 млн ₸ → 41 млн
          ₸)
        </p>
        <DataTable
          value={[
            {
              borrower: "АО НК «КазМунайГаз»",
              creditor: "АО «Kazatomprom»",
              sum: 33000000,
              highlight: true,
            },
            {
              borrower: "АО «Kazatomprom»",
              creditor: "АО «Халык Банк Казахстана»",
              sum: "8000000",
              highlight: true,
            },
            {
              borrower: "АО «Халык Банк Казахстана»",
              creditor: "АО НК «КазМунайГаз»",
              sum: "0",
              highlight: true,
            },
          ]}
          tableStyle={{ minWidth: "50rem" }}
        >
          <Column field="borrower" header="Должник"></Column>
          <Column field="creditor" header="Кредитор"></Column>
          <Column field="sum" header="Сумма (₸)"></Column>
        </DataTable>

        <div className={styles.btnWrapper}>
          <Button
            className={styles.paginationBtn}
            onClick={() => navigate("/generated_pdf")}
          >
            Сформировать акт
          </Button>
        </div>
      </div>
    </div>
  );
};
